<template>
	<div id="App">
		<!-- <Navbar v-if="this.lang == 'id'"></Navbar>
		<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>
		<div class="langApp">
			<div class="btn-group dropstart">
				<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
						<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#3e4095"/>
					</svg>
				</button>
				<ul class="dropdown-menu">
					<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
					<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

				</ul>
			</div>
		</div> -->
	</div>
	<router-view />
</template>

<script>
// import Navbar from '@/components/Navbar.vue'
// import NavbarEn from '@/components/NavbarEn.vue'

export default {
    name: 'App',
	// components: {
	// 	Navbar,
	// 	NavbarEn,
	// },
	// data() {
	// 	return {
	// 		activeLanguage: this.lang
	// 	};
	// },
	// created(){
	// 	this.activeLanguage = localStorage.getItem('activeLanguage')
	// },
	// methods: {
	// 	selectLanguage(lang) {
    //         this.activeLanguage = lang;
    //         this.lang = lang;
            
    //         localStorage.setItem("lang", this.activeLanguage);
    //     }
	// }
}

</script>


<style>
	#app {
		font-family: 'Poppins', sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #585858;
	}
	.KatList{
		position: fixed;
		top: 130px;
		left: 0;
		z-index: 100;
	}
	.langApp{
		position: fixed;
		top: 130px;
		right: 0;
		z-index: 100;
		background: white;
		padding: 0 10px 0 0;
		display: flex;
		justify-content: center;
	}
	.langApp svg{
		margin-bottom: -2px;
	}
	.langApp button.btn{
		box-shadow: none;
		border: none;
		z-index: 1;
		position: relative;
	}
	.langApp .dropdown-menu{
		margin-top: 10px;
		border: none;
		border-radius: 0;
		margin-right: -40px !important;
		z-index: -1;
		position: relative;
		/* box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05); */
	}
	.langApp .dropdown-menu a{
		margin-top: 5px !important;
		padding-top: 2px;
	}
	.langApp .lang-link{
		font-weight: bold;
		padding: 0 15px;
		text-decoration: none;
		color: var(--primary-);
	}
	.langApp .lang-link:hover{
		color: var(--secondary-);
		cursor: pointer;
	}
	.langApp .lang-link.link__active{
		font-weight: bold;
		padding: 0 15px;
		text-decoration: none;
		color: var(--secondary-);
	}

	/* ======= Navbar ======= */
	#nav{
		background: white;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
		/* height: 150px; */
		padding: 20px 0;
	}
	#nav .navbar-brand img{
		width: 100px;
		height: auto;
	}

	#nav a {
		font-weight: 600;
		color: var(--primary-);
		text-transform: uppercase;
	}
	#nav a.dropdown-toggle{
		margin-top: -8px;
	}

	#nav a.router-link-exact-active {
		color: var(--secondary-);
	}

	#nav .lang{
		display: flex;
	}
	#nav .lang .nav-link:hover{
		cursor: pointer;
	}
	#nav .lang .nav-link.link{
		color: var(--secondary-);
		opacity: 0.6;
		padding: 5px;
		transition: 0.5s ease-in-out;
		background: none;
		border: none;
	}
	#nav .lang .nav-link.link:hover{
		opacity: 1;
	}
	#nav .lang .nav-link.link__active{
		color: var(--secondary-);
		opacity: 1;
	}
	#nav .bm{
		display: none !important;
	}
	
	@media (max-width: 768px)
	{
		#nav .navbar-brand img{
			width: 70px;
		}
		#nav .lang{
			justify-content: center;
		}
		#nav .do{
			display: none !important;
		}
		#nav .bm{
			display: flex !important;
			border: 1px solid #3e3f9550;
			padding: 5px;
			background: var(--light-grey-);
		}
	}
	/* ======= Navbar ======= */

	.next-b {
        border-top: 5px solid var(--secondary-);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
        padding: 10px;
    }
    .next-b h5.title-b{
        font-weight: 600;
        padding-bottom: 15px;
    }

    a.l-b{
		text-decoration: none;
	}
	a.l-b:hover > .b-list{
		border: 1px solid var(--secondary-);
	}
	a.l-b .b-list{
		background: white;
		display: flex;
		border: 1px solid white;
		transition: 0.3s ease-in-out;
        margin-top: 15px;
	}
	a.l-b .b-list .thumb{
		width: 150px;
	}
	a.l-b .b-list .thumb img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	a.l-b .b-list .content{
		padding: 20px 10px 0;
		width: 80%;
	}
	a.l-b .b-list .content h5{
		text-decoration: none;
		color: var(--dark-grey-);
		font-weight: 600;
	}
	a.l-b .b-list .content h5:hover{
		color: var(--secondary-);
	}

	a.l-b .b-list .content p{
		color: #a2a2a2;
		padding-top: 15px;
	}
	a.l-b .b-list .content p svg{
		width: 16px;
		height: 16px;
		margin-right: 5px;
	}
	
</style>